import { createContext } from 'react'

export interface IGeneratorClientProposal {
  adults?: number
  clientProposalId?: string
  houseId?: string
}

export const GeneratorClientProposalContext = createContext(
  {} as IGeneratorClientProposal,
)
